import { render, staticRenderFns } from "./KdsProfilesTable.vue?vue&type=template&id=301f610a&"
import script from "./KdsProfilesTable.vue?vue&type=script&lang=js&"
export * from "./KdsProfilesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports